var Backbone = require('backbone')
var _ = require('lodash')

var Model = Backbone.Model.extend({
  // save: function (data, options) {
  //   var isNew
  //   if (options == null) {
  //     options = {}
  //   }
  //   isNew = this.isNew()
  //   _.defaults(options, {
  //     wait: true,
  //     success: _.bind(this.saveSuccess, this, isNew, options.collection, options.callback)
  //   //   error: _.bind(this.saveError, this)
  //   })
  //   this.unset('_errors')
  //   return Model.__super__.save.call(this, data, options)
  // },
  // saveSuccess: function (isNew, collection, callback) {
  //   if (isNew) {
  //     if (collection != null) {
  //       collection.add(this)
  //     }
  //     if (collection != null) {
  //       collection.trigger('model:created', this)
  //     }
  //     this.trigger('created', this)
  //   } else {
  //     if (collection == null) {
  //       collection = this.collection
  //     }
  //     if (collection != null) {
  //       collection.trigger('model:updated', this)
  //     }
  //     this.trigger('updated', this)
  //   }
  //   return typeof callback === 'function' ? callback() : void 0
  // }

})

module.exports = Model



// WEBPACK FOOTER //
// ./js/common/base-model.js